export const BACKEND_CLIENT_VERSION = '7.0.0';
